

import React, { useState, useEffect } from 'react';

import {
  Search,
  MapPin,
  Star,
  Phone,
  MessageCircle,
  Eye,
  Filter,
  Map,
  Satellite,
  Navigation,
  Clock,
  Award,
  Zap,
  X,
} from "lucide-react"
import styles from './RedesignedMapResult.module.css';

const RedesignedMapResult = () => {
  const [viewMode, setViewMode] = useState("map")
  const [selectedBusiness, setSelectedBusiness] = useState(null)
  const [showFilters, setShowFilters] = useState(false)

  const searchResults = [
    {
      id: 1,
      name: "SUPER SPARKS",
      address: "12 John St, CABRAMATTA, NSW",
      phone: "0433333333",
      rating: 4.0,
      reviewCount: 1,
      services: ["ON-SITE SERVICES"],
      sponsored: true,
      verified: true,
      responseTime: "Usually responds within 2 hours",
      completedJobs: 150,
      avatar: "SS",
    },
    {
      id: 2,
      name: "Sky High Energy",
      address: "25 George Street, Liverpool, NSW",
      phone: "0412 333 999",
      rating: 4.6,
      reviewCount: 1,
      services: ["ON-SITE SERVICES"],
      sponsored: true,
      verified: true,
      responseTime: "Usually responds within 1 hour",
      completedJobs: 280,
      avatar: "SH",
    },
    {
      id: 3,
      name: "PowerTech Solutions",
      address: "45 Main Road, Fairfield, NSW",
      phone: "0455 777 888",
      rating: 4.8,
      reviewCount: 23,
      services: ["RESIDENTIAL", "COMMERCIAL"],
      sponsored: false,
      verified: true,
      responseTime: "Usually responds within 4 hours",
      completedJobs: 420,
      avatar: "PT",
    },
    {
      id: 4,
      name: "Elite Electrical",
      address: "78 Park Avenue, Canley Vale, NSW",
      phone: "0466 555 444",
      rating: 4.3,
      reviewCount: 8,
      services: ["EMERGENCY SERVICES"],
      sponsored: false,
      verified: false,
      responseTime: "Usually responds within 6 hours",
      completedJobs: 95,
      avatar: "EE",
    },
  ]

  const BusinessCard = ({ business, isSelected }) => (
    <div
      className={`${styles.businessCard} ${isSelected ? styles.businessCardSelected : ""}`}
      onClick={() => setSelectedBusiness(business.id === selectedBusiness ? null : business.id)}
    >
      <div className={styles.businessCardContent}>
        {business.sponsored && (
          <div className={styles.sponsoredSection}>
            <span className={`${styles.badge} ${styles.badgeSecondary}`}>
              <Zap className={styles.badgeIcon} />
              SPONSORED
            </span>
            {business.verified && (
              <span className={`${styles.badge} ${styles.badgeVerified}`}>
                <Award className={styles.badgeIcon} />
                VERIFIED
              </span>
            )}
          </div>
        )}

        <div className={styles.businessInfoSection}>
          <div className={styles.businessAvatarContainer}>
            <div className={`${styles.avatarFallback} ${styles.avatarFallbackAmber}`}>{business.avatar}</div>
          </div>

          <div className={styles.businessDetails}>
            <h3 className={styles.businessName}>{business.name}</h3>
            <div className={styles.ratingSection}>
              <div className={styles.starsContainer}>
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    className={`${styles.starIcon} ${i < Math.floor(business.rating) ? styles.starIconFilled : styles.starIconEmpty}`}
                  />
                ))}
                <span className={styles.ratingValue}>{business.rating.toFixed(1)}</span>
                <span className={styles.reviewCount}>({business.reviewCount})</span>
              </div>
            </div>

            <div className={styles.addressSection}>
              <MapPin className={styles.addressIcon} />
              <span className={styles.addressText}>{business.address}</span>
            </div>

            <div className={styles.phoneSection}>
              <Phone className={styles.phoneIcon} />
              <span className={styles.phoneTextValue}>{business.phone}</span>
            </div>
          </div>
        </div>

        <div className={styles.additionalInfoSection}>
          <div className={styles.responseTimeSection}>
            <Clock className={styles.timeIcon} />
            {business.responseTime}
          </div>
          <div className={styles.completedJobsSection}>
            <Award className={styles.jobsIcon} />
            {business.completedJobs} jobs completed
          </div>
        </div>

        <div className={styles.servicesSection}>
          {business.services.map((service, index) => (
            <span key={index} className={`${styles.badge} ${styles.badgeOutline}`}>
              {service}
            </span>
          ))}
        </div>

        <div className={styles.actionsSection}>
          <button className={`${styles.btn} ${styles.btnPrimary} ${styles.messageButton}`}>
            <MessageCircle className={styles.buttonIcon} />
            Message
          </button>
          <button className={`${styles.btn} ${styles.btnOutline} ${styles.viewProfileButton}`}>
            <Eye className={styles.buttonIcon} />
            View Profile
          </button>
        </div>
      </div>
    </div>
  )

  return (
    <div className={styles.rootContainer}>
      {/* Header */}
      <div className={styles.header}>
        <div className={styles.headerContent}>
          <div className={styles.headerLeft}>
            <div className={styles.headerLogo}>
              <div className={styles.logoIconContainer}>
                <Search className={styles.logoIcon} />
              </div>
              <h1 className={styles.headerTitle}>SEARCH</h1>
            </div>
          </div>
        </div>
      </div>

      {/* Search Bar */}
      <div className={styles.searchBarContainer}>
        <div className={styles.searchBarContent}>
          <div className={styles.searchBarInner}>
            <div className={styles.searchInputWrapper}>
              <div className={styles.searchInputMain}>
                <div className={styles.searchLocationSection}>
                  <MapPin className={styles.searchIcon} />
                  <div>
                    <div className={styles.searchTextLabel}>Where</div>
                    <div className={styles.searchTextValue}>2166</div>
                  </div>
                </div>

                <div className={styles.searchDivider}></div>

                <div className={`${styles.searchServiceSection} ${styles.searchServiceInput}`}>
                  <Search className={styles.searchIcon} />
                  <div className={styles.searchServiceInput}>
                    <div className={styles.searchTextLabel}>Who or what service is required</div>
                    <div className={styles.searchTextValue}>Electrician</div>
                  </div>
                </div>
              </div>

              <button className={`${styles.btn} ${styles.btnGhost} ${styles.clearSearchButton}`}>
                <X className={styles.clearSearchIcon} />
              </button>
            </div>

            <button className={`${styles.btn} ${styles.btnOutline}`} onClick={() => setShowFilters(!showFilters)}>
              <Filter className={styles.buttonIcon} />
              Filters
            </button>

            <button className={`${styles.btn} ${styles.btnPrimary}`}>
              <Search className={styles.buttonIcon} />
              Search
            </button>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className={styles.mainContentContainer}>
        <div className={styles.mainContentLayout}>
          {/* Results Sidebar */}
          <div className={styles.resultsSidebar}>
            <div className={styles.resultsHeader}>
              <h2 className={styles.resultsTitle}>Return 6 results for "Electrician" in 2166</h2>
              <div className={styles.resultsMeta}>
                <span>Results</span>
                <div className={styles.resultsInfoIconContainer}>
                  <span className={styles.resultsInfoIconText}>i</span>
                </div>
              </div>
            </div>

            <div className={styles.resultsList}>
              {searchResults.map((business) => (
                <BusinessCard key={business.id} business={business} isSelected={selectedBusiness === business.id} />
              ))}
            </div>
          </div>

          {/* Map Section */}
          <div className={styles.mapContainer}>
            <div className={styles.mapCard}>
              <div className={styles.mapCardHeader}>
                <div className={styles.mapCardTitleSection}>
                  <h3 className={styles.mapCardTitle}>Map View</h3>
                </div>

                <div className={styles.mapViewControls}>
                  <div className={styles.viewModeToggleContainer}>
                    <button
                      className={`${styles.viewModeButton} ${viewMode === "map" ? styles.viewModeButtonActive : styles.viewModeButtonInactive}`}
                      onClick={() => setViewMode("map")}
                    >
                      <Map className={styles.viewModeIcon} />
                      Map
                    </button>
                    <button
                      className={`${styles.viewModeButton} ${viewMode === "satellite" ? styles.viewModeButtonActive : styles.viewModeButtonInactive}`}
                      onClick={() => setViewMode("satellite")}
                    >
                      <Satellite className={styles.viewModeIcon} />
                      Satellite
                    </button>
                  </div>

                  <button className={`${styles.btn} ${styles.btnOutline} ${styles.btnSm} ${styles.navigationButton}`}>
                    <Navigation className={styles.navigationIcon} />
                  </button>
                </div>
              </div>

              <div className={styles.mapCardContent}>
                {/* Map Placeholder */}
                <div className={styles.mapPlaceholder}>
                  <div className={styles.mapPlaceholderOverlay}>
                    <div className={styles.mapPlaceholderOverlayGradient}></div>
                  </div>

                  {/* Map Pins */}
                  <div className={`${styles.mapPinBase} ${styles.mapPin1}`}>
                    <MapPin className={styles.mapPinIcon} />
                  </div>

                  <div className={`${styles.mapPinBase} ${styles.mapPin2}`}>
                    <MapPin className={styles.mapPinIcon} />
                  </div>

                  <div className={`${styles.mapPinBase} ${styles.mapPin3}`}>
                    <MapPin className={styles.mapPinIcon} />
                  </div>

                  <div className={`${styles.mapPinBase} ${styles.mapPin4}`}>
                    <MapPin className={styles.mapPinIcon} />
                  </div>

                  <div className={styles.mapPlaceholderTextContainer}>
                    <Map className={styles.mapPlaceholderIcon} />
                    <p className={styles.mapPlaceholderTextMedium}>Interactive Map View</p>
                    <p className={styles.mapPlaceholderTextSmall}>Showing electricians in 2166 area</p>
                  </div>
                </div>

                {/* Map Controls */}
                <div className={styles.mapControls}>
                  <button className={`${styles.btn} ${styles.btnOutline} ${styles.btnSm} ${styles.mapControlButton}`}>
                    <span className={styles.mapControlText}>+</span>
                  </button>
                  <button className={`${styles.btn} ${styles.btnOutline} ${styles.btnSm} ${styles.mapControlButton}`}>
                    <span className={styles.mapControlText}>−</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RedesignedMapResult
